/**
 * Phase 36 — one small line with a container's running experiment as the
 * day laid it out: the lane (Phase 40 — "23Telecom · AUSSIEWIN"), its share, how many of today's drops it
 * took (none: paused today, or no drops to take — the warnings say which).
 * Nothing without one, nor for someone who cannot see experiments.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DayPlanExperimentMark } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

import { useCanSeeExperiments } from './use-can-see-experiments';

export function experimentLineWords(mark: DayPlanExperimentMark): string {
  const gateway = mark.laneLabel ?? mark.routeName ?? `gateway #${mark.routeId}`;
  if (mark.drops === 0) return `🧪 experiment — ${gateway} gets ${mark.sharePct} % of the drops · none reserved today`;
  return `🧪 experiment — ${gateway} gets ${mark.sharePct} % of the drops · ${mark.drops} today`;
}

export const ExperimentLine: FC<{ experiment: DayPlanExperimentMark | null | undefined; className?: string }> = ({ experiment, className }) => {
  const canSee = useCanSeeExperiments();
  if (!experiment || !canSee) return null;
  return (
    <span
      data-testid="experiment-line"
      title={
        experiment.drops === 0
          ? "No drop reserved today: the experiment pauses when its gateway is blocked, gone from the pool or alone (a warning says so) — or the day has no unpinned drop to take. Gateways tab, Experiment."
          : "A time-boxed gateway test: a share of every day's drops goes through this gateway and is compared with the others — Gateways tab, Experiment."
      }
      className={cn('truncate text-[11px] tabular-nums', experiment.drops === 0 ? 'text-warning' : 'text-primary', className)}
    >
      {experimentLineWords(experiment)}
    </span>
  );
};
